var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 21.67 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.09 2.83c1.53-1.18 2.85-.97 3.47.42C7.82 5.75 8.72 7 7.82 7.98 6.15 9.09 4.97 9.65 5.6 10.83c1.25 2.99 3.68 5.56 6.6 7.09 1.11.69 1.74-.49 2.99-2.01 1.04-.83 2.22.07 4.66 1.53 1.32.76 1.39 2.01.14 3.47C12.68 29.1-5.59 9.57 3.09 2.83",
    clipRule: "evenodd"
  })));
};
export default SvgPhone;